// src/config/emailConfig.js
/**
 * Configuration for the Direct Contact Email Form
 *
 * HOW TO MAKE THIS WORK 100% IN 30 SECONDS (FREE, NO BACKEND REQUIRED):
 * 1. Visit: https://web3forms.com
 * 2. Enter your email: mdismail.cse59@gmail.com
 * 3. Click "Create Access Key" — check your inbox and copy your Access Key.
 * 4. Paste your key below into WEB3FORMS_ACCESS_KEY.
 * 5. That's it! Every message submitted on your portfolio will be delivered directly to your inbox.
 */

export const EMAIL_CONFIG = {
  // Replace this with your free key from https://web3forms.com
  // Once pasted, any recruiter or visitor who submits the contact form will send an email straight to mdismail.cse59@gmail.com!
  WEB3FORMS_ACCESS_KEY: 'YOUR_ACCESS_KEY_HERE',

  // Your recipient details
  RECIPIENT_EMAIL: 'mdismail.cse59@gmail.com',
  RECIPIENT_NAME: 'MD Ismail Hosen',
  PHONE: '+880 1619-524736',
  WHATSAPP_LINK: 'https://wa.me/8801619524736',
  LOCATION: 'Mohakhali, Dhaka, Bangladesh',
  LINKEDIN_URL: 'https://linkedin.com/in/ismail554',
  GITHUB_URL: 'https://github.com/Ismail554',
  PORTFOLIO_URL: 'https://my-portfolio-lake-three-88.vercel.app/'
};
